import React, { useState, useRef, useEffect } from 'react'
import { Switch, message, Button, Progress, Icon, Modal, Input, Tooltip, Checkbox } from 'antd'
import { Link } from 'react-router-dom'
import { createRule, updateRule } from '../../../../services/api/3dApi'
import getHistory from '../../../../helpers/rounting/getHistory'

function RuleCreateBatchRow(props) {
    const { item = {}, setType, setPage, updateSelectedItems, selectedItems = [], reset } = { ...props }
    const {
        partner,
        priority,
        products,
        required_tags,
        stores,
        schedule,
        only_package,
        only_store,
        batch_info,
        quantity,
        condition = [],
        is_fit = false,
        split_by_pack = false,
        variants = [],
        fit_condition
    } = { ...item }
    const Quantity = quantity || {}
    const onlyPackage = only_package
    const onlyStore = only_store
    // const userCreate = batch_info.user_create
    // const batchPartner = batch_info.partner
    // const batchQuantity = batch_info.limit_quantity
    const {
        quantity: conditionQty,
        batch_info: conditionBatchInfo,
    } = { ...condition }

    const { frames = [] } = { ...fit_condition }

    const [status, setStatus] = useState(item.is_active || false)
    const [loadingStatus, setLoadingStatus] = useState(false)
    const [hoverRule, setHoverRule] = useState()
    const [hoverCondition, setHoverCondition] = useState()
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [priorityClone, setPriorityClone] = useState('')
    const [validate, setValidate] = useState({})
    const [errors, setErrors] = useState('')
    const [showAllRole, setShowAllRole] = useState(false)
    const [showAllTag, setShowAllTag] = useState(false)
    const [showAllStore, setShowAllStore] = useState(false)
    const [showAllSizeOfMaterials, setShowAllSizeOfMaterials] = useState(false)
    const [showAllVariant, setShowAllVariant] = useState(false)

    useEffect(() => {
        setStatus(item.is_active)
    }, [item.is_active])

    const showallonclick = (type) => {
        if (type === 'SKU') setShowAllRole(!showAllRole)
        if (type === 'Tag') setShowAllTag(!showAllTag)
        if (type === 'Store') setShowAllStore(!showAllStore)
        if (type === 'SizeOfMaterials') setShowAllSizeOfMaterials(!showAllSizeOfMaterials)
        if (type === 'Variant') setShowAllVariant(!showAllVariant)
    }

    const refSKU = useRef()
    const refTag = useRef()
    const refStore = useRef()
    const refSizeOfMaterials = useRef()
    const refVariant = useRef()

    const getQuantity = (quantity) => {
        const { amount, condition } = quantity
        const check = {
            gt: '>',
            lt: '<',
            gte: '>=',
            lte: '<=',
            eq: '=',
        }
        return !!amount && !!check[condition] ? `${check[condition]} ${amount}` : '-'
    }

    const getPartner = (partner) => {
        const { code, name } = partner
        if (name) {
            if (code) {
                return `${name} (${code})`
            }
            return name
        }
        return '-'
    }

    const getTag = (Tag) => {
        const { mode, tags = [] } = { ...Tag }
        if (mode === 'exclude') {
            return (
                <>
                    <div className={showAllTag === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                        <div ref={refTag}>
                            <label className="w-100 mb-0">All</label>
                            {
                                !!tags && !!Object.keys(tags).length &&
                                <label className="text-danger">{tags.join(', ')}</label>
                            }
                        </div>
                    </div>
                    {
                        !!refTag.current ? (
                            (refTag.current.offsetHeight > 85 && showAllTag === false) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('Tag')}>More...</small>
                                </a> :
                                (refTag.current.offsetHeight > 85 && showAllTag === true) ?
                                    <a className="float-right mr-3 text-primary">
                                        <small className="float-right" onClick={() => showallonclick('Tag')}>Less...</small>
                                    </a> : ""
                        ) : ""
                    }
                </>
            )
        }
        return (!!tags && !!Object.keys(tags).length &&
            <>
                <div className={showAllTag === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                    <div ref={refTag}>
                        <label className='mb-0'>{tags.join(', ')}</label>
                    </div>
                </div>
                {
                    !!refTag.current ? (
                        (refTag.current.offsetHeight > 85 && showAllTag === false) ?
                            <a className="float-right mr-3 text-primary">
                                <small className="float-right" onClick={() => showallonclick('Tag')}>More...</small>
                            </a> :
                            (refTag.current.offsetHeight > 85 && showAllTag === true) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('Tag')}>Less...</small>
                                </a> : ""
                    ) : ""
                }
            </>
        )
    }

    const getSchedule = (schedule) => {
        const { start, end } = schedule
        if (start && end) {
            return `${start} - ${end}`
        }
        return start
    }

    const getStore = (Store) => {
        const { mode, list = [] } = { ...Store }
        if (mode === 'exclude') {
            return (
                <>
                    <div className={showAllStore === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                        <div ref={refStore}>
                            <label className="w-100 mb-0">All</label>
                            {
                                !!list && !!Object.keys(list).length &&
                                <label className="text-danger">{list.join(', ')}</label>
                            }
                        </div>
                    </div>
                    {
                        !!refStore.current ? (
                            (refStore.current.offsetHeight > 85 && showAllStore === false) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('Store')}>More...</small>
                                </a> :
                                (refStore.current.offsetHeight > 85 && showAllStore === true) ?
                                    <a className="float-right mr-3 text-primary">
                                        <small className="float-right" onClick={() => showallonclick('Store')}>Less...</small>
                                    </a> : ""
                        ) : ""
                    }
                </>
            )
        }
        return (!!list && !!Object.keys(list).length &&
            <>
                <div className={showAllStore === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                    <div ref={refStore}>
                        <label className='mb-0'>{list.join(', ')}</label>
                    </div>
                </div>
                {
                    !!refStore.current ? (
                        (refStore.current.offsetHeight > 85 && showAllStore === false) ?
                            <a className="float-right mr-3 text-primary">
                                <small className="float-right" onClick={() => showallonclick('Store')}>More...</small>
                            </a> :
                            (refStore.current.offsetHeight > 85 && showAllStore === true) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('Store')}>Less...</small>
                                </a> : ""
                    ) : ""
                }
            </>
        )
    }

    const getSku = (Sku) => {
        const { mode, sku = [] } = { ...Sku }
        if (mode === 'exclude') {
            return (
                <>
                    <div className={showAllRole === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                        <div ref={refSKU}>
                            <label className="w-100 mb-0">All</label>
                            {
                                !!sku && !!Object.keys(sku).length &&
                                <label className="text-danger">{sku.join(', ')}</label>
                            }
                        </div>
                    </div>
                    {
                        !!refSKU.current ? (
                            (refSKU.current.offsetHeight > 85 && showAllRole === false) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('SKU')}>More...</small>
                                </a> :
                                (refSKU.current.offsetHeight > 85 && showAllRole === true) ?
                                    <a className="float-right mr-3 text-primary">
                                        <small className="float-right" onClick={() => showallonclick('SKU')}>Less...</small>
                                    </a> : ""
                        ) : ""
                    }
                </>
            )
        }
        return (
            !!sku && !!Object.keys(sku).length &&
            <>
                <div className={showAllRole === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                    <div ref={refSKU}>
                        <label className='mb-0'>{sku.join(', ')}</label>
                    </div>
                </div>
                {
                    !!refSKU.current ? (
                        (refSKU.current.offsetHeight > 85 && showAllRole === false) ?
                            <a className="float-right mr-3 text-primary">
                                <small className="float-right" onClick={() => showallonclick('SKU')}>More...</small>
                            </a> :
                            (refSKU.current.offsetHeight > 85 && showAllRole === true) ?
                                <a className="float-right mr-3 text-primary">
                                    <small className="float-right" onClick={() => showallonclick('SKU')}>Less...</small>
                                </a> : ""
                    ) : ""
                }
            </>
        )
    }

    const handleChangeStatusRule = async () => {
        setLoadingStatus(true)
        const newVariants = variants.map(item => ({
            ...item,
            conditions: item.conditions.map(condition => ({
                ...condition,
                partner: condition.partner._id
            }))
        }))

        const payload = {
            ...item,
            priority: priority,
            partner: partner._id,
            variants: newVariants,
            is_active: !status,
        }

        try {
            const { data: res } = await updateRule(item._id, payload)
            const { success, error: mess, data } = { ...res }
            if (!success) throw new Error(mess)
            message.success('Update status successfully!')
            setStatus(data.is_active || false)

        } catch (e) {
            const { data: resErr } = { ...e.response }
            const { message: ErrMess } = { ...resErr }
            message.error(ErrMess || e.message)
        } finally {
            setLoadingStatus(false)
            reset()
        }
    }

    const onHoverCondition = (condition, i) => () => {
        setHoverCondition(i)
    }

    const onLeaveCondition = (condition, i) => () => {
        setHoverCondition('')
    }

    const conditionWrap = (text, condition, i, is_fit) => {
        const { quantity } = { ...condition }
        const { lte, gt } = { ...quantity }
        if (is_fit) {
            return <Progress key={i} percent={gt} size='large' strokeColor="#03a9f4" style={{ marginBottom: 2 }} />
        }
        return <p
            title={!condition.is_enable ? 'Condition is not enabled' : ''}
            className={[hoverCondition === i ? 'Hover' : '', !condition.is_enable && 'Inactive'].filter(Boolean).join(' ')}
            onMouseEnter={onHoverCondition(condition, i)}
            onMouseLeave={onLeaveCondition(condition, i)}
            key={i}>{text || '-'}</p>
    }

    const getConditionQty = (condition, i, is_fit) => {
        const { quantity } = { ...condition }
        const { lte, gt } = { ...quantity }
        const strs = []

        if (gt > 0 && lte && lte !== Infinity) {
            strs.push(`${gt} < ... <= ${lte}`)
        } else {
            if (gt > 0) {
                strs.push(`> ${gt}`)
            }

            if (lte) {
                strs.push(lte === Infinity ? '' : `<= ${lte}`)
            }
        }

        return conditionWrap(strs.filter(Boolean).join(', '), condition, i, is_fit)
    }

    const getConditionUserCreate = (condition, i) => {
        const { batch_info: batchInfo } = { ...condition }

        return conditionWrap(batchInfo && batchInfo.user_create, condition, i)
    }

    const getConditionPartner = (condition, i) => {
        const { batch_info: batchInfo } = { ...condition }

        return conditionWrap(batchInfo && batchInfo.partner && batchInfo.partner.name || '-', condition, i)
    }

    const getConditionBatchQty = (condition, i) => {
        const { batch_info: batchInfo } = { ...condition }

        return conditionWrap(batchInfo && batchInfo.limit_quantity, condition, i)
    }

    const toggleModalClone = () => {
        setPriorityClone('')
        setValidate({})
        setIsOpenModal(!isOpenModal)
    }

    const handleCloneRule = async () => {
        setErrors('')
        if (Validate()) return

        const newVariants = variants.map(item => ({
            ...item,
            conditions: item.conditions.map(condition => ({
                ...condition,
                partner: condition.partner._id
            }))
        }))

        const payload = {
            ...item,
            priority: priorityClone,
            partner: partner._id,
            variants: newVariants
        }

        try {
            const { data: res } = await createRule(payload)
            const { success, error: mess } = res
            if (!success) {
                throw new Error(mess)
            }
            message.success('Rule created!!!')
            const history = getHistory()
            //history.push(`/list-rule-create-batch`)
            history.push(`/edit-rule/${res.data._id}`)
            setErrors('')
        } catch (error) {
            message.error(error.message)
            setErrors(error.message)
        }
    }

    const handleChangePriority = (e) => {
        delete validate['priority']
        setValidate(validate)

        setPriorityClone(parseFloat(e.target.value))
    }

    const Validate = () => {
        const errorValidate = {}
        if (!priorityClone) {
            errorValidate.priority = 'Please input priority!!!'
        }

        setValidate(errorValidate)
        if (!!Object.keys(errorValidate).length) {
            return true
        }
        return false
    }

    return (
        <tr className="RowBatchRule" key={item._id}>
            <td className='selectRow' style={{ width: 40 }}>
                <Checkbox checked={selectedItems.includes(item._id)} onChange={() => updateSelectedItems(item._id, !(selectedItems.includes(item._id)))} />
            </td>
            <td className="BatchSelectedAll">
                {priority}
            </td>
            <td>
                {getPartner(partner) || '-'}
            </td>
            <td className="Sku">
                {getSku(products) || '-'}
            </td>
            <td className="Tags">
                {getTag(required_tags) || '-'}
            </td>
            <td className="Stores">
                {getStore(stores) || '-'}
            </td>
            <td className='ruleType'>
                {is_fit ? 'Diện tích' : 'Số lượng'}
            </td>
            <td>
                <Checkbox checked={onlyPackage} />
            </td>
            <td>
                <Checkbox checked={onlyStore} />
            </td>
            <td>{getSchedule(schedule) || '-'}</td>
            <td>
                {is_fit && frames.length > 0 ?
                    <>
                        <div className={showAllSizeOfMaterials === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                            <div ref={refSizeOfMaterials}>
                                {frames.map((i, idx) => (
                                    <div key={`${item._id}_KhoNVL_${idx}`}>
                                        <Tooltip title={`${(!!i.w || i.w === 0) ? 'Width' : ''}${((!!i.w || i.w === 0) && (!!i.h || i.h === 0)) ? ' x ' : ''}${(!!i.h || i.h === 0) ? 'Height' : ''}`}>
                                            <span>
                                                {`${i.w || 0} x ${i.h || 0}`}
                                            </span>
                                        </Tooltip>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {
                            !!refSizeOfMaterials.current ? (
                                (refSizeOfMaterials.current.offsetHeight > 85 && showAllSizeOfMaterials === false) ?
                                    <a className="float-right mr-3 text-primary">
                                        <small className="float-right" onClick={() => showallonclick('SizeOfMaterials')}>More...</small>
                                    </a> :
                                    (refSizeOfMaterials.current.offsetHeight > 85 && showAllSizeOfMaterials === true) ?
                                        <a className="float-right mr-3 text-primary">
                                            <small className="float-right" onClick={() => showallonclick('SizeOfMaterials')}>Less...</small>
                                        </a> : ""
                            ) : ""
                        }
                    </> : ''}
            </td>
            <td>
                {!is_fit && variants.length > 0 ?
                    <>
                        <div className={showAllVariant === false ? "LessItems" : ""} style={{ maxWidth: 190 }}>
                            <div ref={refVariant}>
                                {variants.map((i, idx) => (
                                    i.name !== '__ALL_SIZE__' &&
                                    <div key={`${item._id}_variant_${idx}`}>{i.name}</div>
                                ))}
                            </div>
                        </div>
                        {
                            !!refVariant.current ? (
                                (refVariant.current.offsetHeight > 85 && showAllVariant === false) ?
                                    <a className="float-right mr-3 text-primary">
                                        <small className="float-right" onClick={() => showallonclick('Variant')}>More...</small>
                                    </a> :
                                    (refVariant.current.offsetHeight > 85 && showAllVariant === true) ?
                                        <a className="float-right mr-3 text-primary">
                                            <small className="float-right" onClick={() => showallonclick('Variant')}>Less...</small>
                                        </a> : ""
                            ) : ""
                        }
                    </> : ''}
            </td>
            <td>
                <Switch checked={status} onChange={handleChangeStatusRule} disabled={loadingStatus} />
            </td>
            <td>
                {item._id &&
                    <span className="text-primary">
                        <Link className="linkDetail" to={`/edit-rule/${item._id}`}>
                            <Button type="link" icon="edit" />
                        </Link>
                    </span>
                }

                <Tooltip title="Clone Rule">
                    <Icon
                        type="copy"
                        className="cursor-pointer"
                        onClick={toggleModalClone}
                    />
                </Tooltip>

                <Modal title="Clone Rule" visible={isOpenModal} okText="Clone" onOk={handleCloneRule} onCancel={toggleModalClone}>
                    <div className='CloneRuleContainer'>
                        <label>Priority<span style={{ color: 'red' }}> *</span></label>
                        <Input
                            type="number"
                            className={(!!validate.priority && validate.priority.length > 0) ? 'Error' : ''}
                            value={priorityClone || ''}
                            placeholder="Priority"
                            onChange={e => handleChangePriority(e)}
                        />

                        {
                            !!validate.priority && validate.priority.length > 0 &&
                            <small className="Validate" style={{ color: 'red' }}>{validate.priority}</small>
                        }
                    </div>
                </Modal>
            </td>
        </tr>
    )
}

export default RuleCreateBatchRow